export class ActiveRateCodeModel {
    constructor(
        public id: number,
        public productId: number,
        public productName: string,
        public salesChannelDesc: string,
        public salesChannelFieldValue: string,
        public corp: any,
        public corps :number [],
        public changeColor : boolean [],
        public rcode: string,
        public rdesc: string,
        public valid_from_dt: Date,
        public valid_to_dt: Date
    ) { }
}
